import { TFunction } from "i18next";

export const getEnumOptionsWithTranslations = (
    enumObj: Object,
    scope: string,
    t: TFunction
) => {
    return Object.values(enumObj).map((value) => ({
        label: t(`${scope}.${value}`),
        value: value
    }))
}